<!-- Header -->
<app-header></app-header>

@if (loading) {
  <!-- Loading State -->
  <section class="section-pad" style="background-color: #f0eada;">
    <div class="container">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-3 text-accent">Cargando línea...</p>
      </div>
    </div>
  </section>
} @else if (linea) {
  <!-- Hero de la Línea -->
  <section class="section-pad" style="background-color: #f0eada;">
    <div class="container">
      <nav aria-label="breadcrumb" class="mb-4">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/" class="text-dark">Inicio</a></li>
          <li class="breadcrumb-item"><a routerLink="/" fragment="productos" class="text-dark">Líneas</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{ getNombreSinLinea(linea.nombre) }}</li>
        </ol>
      </nav>

      <div class="row align-items-center g-5 mb-5">
        <div class="col-12 col-lg-8">
          <h1 class="display-title mb-4">{{ getNombreSinLinea(linea.nombre) }}</h1>
          <p class="lead-text mb-4">
            {{ linea.descripcion || linea.metaDescription || 'Descubre nuestra colección exclusiva de velas artesanales. Cada pieza está elaborada con dedicación y materiales premium para crear ambientes únicos en tu hogar.' }}
          </p>
          <div class="d-flex flex-wrap gap-3">
            <a href="https://tienda.velas.ar" class="btn btn-primary-custom btn-custom">Ver en Tienda</a>
            <a routerLink="/" class="btn btn-outline-custom btn-custom">Volver al Inicio</a>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          @if (linea.imagen) {
            <img [src]="linea.imagen" [alt]="linea.nombre" class="img-fluid rounded">
          } @else {
            <div class="glass-card p-5 text-center">
              <svg width="150" height="150" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="mx-auto mb-4">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
              </svg>
              <h3 class="fw-bold">{{ getNombreSinLinea(linea.nombre) }}</h3>
            </div>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- Productos de la Línea -->
  @if (productos.length > 0) {
    <section class="section-pad border-top" style="background-color: #f0eada; border-top: 2px solid #e0e0e0 !important;">
      <div class="container">
        <div class="text-center mb-5">
          <h2 class="section-title">Productos de {{ getNombreSinLinea(linea.nombre) }}</h2>
          <p class="section-subtitle">
            Explora nuestra selección de velas artesanales de esta colección. Cada producto está hecho con cera de soja 100% natural y aromas cuidadosamente seleccionados.
          </p>
        </div>
        <div class="row g-4">
          @for (producto of productos; track producto.slug) {
            <div class="col-12 col-md-6 col-lg-4">
              <div class="card-custom h-100 p-4 d-flex flex-column">
                @if (producto.imagen) {
                  <div class="mb-3 product-image-container">
                    <img [src]="producto.imagen" [alt]="producto.nombre" class="product-image">
                  </div>
                }
                <div class="flex-grow-1">
                  <h3 class="fw-bold mb-3">{{ producto.nombre }}</h3>
                  @if (producto.descripcionCorta) {
                    <p class="text-accent mb-3">{{ producto.descripcionCorta }}</p>
                  }
                  <div class="d-flex flex-wrap gap-2 mb-3">
                    @if (producto.aroma) {
                      <span class="badge bg-dark">{{ producto.aroma }}</span>
                    }
                    @if (producto.tipoCera) {
                      <span class="badge bg-dark">{{ producto.tipoCera }}</span>
                    }
                  </div>
                  @if (producto.precio) {
                    <div class="mb-3">
                      <span class="h4 fw-bold">{{ formatCurrency(producto.precio) }}</span>
                      @if (producto.precioAnterior && producto.precioAnterior > producto.precio) {
                        <span class="text-decoration-line-through text-accent ms-2">{{ formatCurrency(producto.precioAnterior) }}</span>
                      }
                    </div>
                  }
                </div>
                <div class="mt-auto">
                  <a href="https://tienda.velas.ar/producto/{{ producto.slug }}" class="btn btn-outline-custom btn-custom w-100">
                    Ver Producto
                  </a>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  } @else {
    <!-- Sin productos -->
    <section class="section-pad border-top" style="background-color: #f0eada; border-top: 2px solid #e0e0e0 !important;">
      <div class="container">
        <div class="text-center">
          <p class="lead-text">Próximamente agregaremos productos a esta línea.</p>
          <a routerLink="/" class="btn btn-outline-custom btn-custom mt-3">Volver al Inicio</a>
        </div>
      </div>
    </section>
  }
}

<!-- Footer -->
<app-footer></app-footer>

